import React from 'react';

export const AnimatedEllipsisText = ({ text }) => {
  const [dots, setDots] = React.useState('.');

  React.useEffect(() => {
    const states = ['.', '..', '...'];
    let i = 0;
    const interval = setInterval(() => {
      i = (i + 1) % states.length;
      setDots(states[i]);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <span>
      {text}
      <span>{dots}</span>
    </span>
  );
};
